<template>
  <div>
    <v-layout wrap pt-15 justify-center>
      <v-flex xs11 text-left pt-16>
        <span
          style="color: #1f1f1f; font-family: poppinssemibold; font-size: 20px"
        >
          Terms And Conditions</span
        >
      </v-flex>
      <v-flex xs11 sm11 md11 lg11 xl11 pt-4  pb-16 text-justify>
        <span
          style="font-family: poppinsregular; font-size: 15px; color: #1a1919"
        >
          <!-- v-html="pageData.details" -->

          Welcome to Eco Shop Kerala! By using our website and services, you
          agree to the following terms and conditions. Please read them
          carefully. <br><br>  
          <b> 1. Acceptance of Terms</b> <br> <br> By accessing and using our website,
          you agree to comply with these Terms and Conditions, along with our
          Privacy Policy. If you do not agree with these terms, please do not
          use our services. <br><br> <b>2. Products and Services</b> <br> <br> We offer a range of
          eco-friendly products aimed at promoting sustainability. All product
          descriptions, prices, and availability are subject to change without
          notice. We make every effort to display our products accurately.
          However, we cannot guarantee that your computer monitor's display of
          any color will be accurate. <br> <br> <b>3. Order Acceptance and Payment</b><br><br> Your order
          constitutes an offer to purchase a product. We reserve the right to
          accept or reject your order at our discretion. Payment must be made at
          the time of purchase. We accept various payment methods, which will be
          specified on our website. <br><br> <b>4. Shipping and Delivery</b><br><br> We aim to process
          and ship your order within [insert processing time]. Delivery times
          may vary based on your location and shipping method. Risk of loss and
          title for items purchased from Eco Shop Kerala pass to you upon
          delivery. <br><br> <b>5. Cancellation and Returns</b> <br><br> Please refer to our Cancellation
          Policy for details on how to cancel an order and our Return Policy for
          information on returning products. <br><br> <b>6. Intellectual Property</b><br> <br>  All
          content on our website, including text, graphics, logos, and images,
          is the property of Eco Shop Kerala or our content suppliers and is
          protected by copyright and trademark laws. You may not reproduce,
          distribute, or create derivative works from any content without our
          express written consent. <br> <br> <b>7. Limitation of Liability</b> <br> <br> Eco Shop Kerala
          will not be liable for any indirect, incidental, or consequential
          damages arising from your use of our website or products. Our
          liability is limited to the maximum extent permitted by law. <br><br> <b>8.
            Governing Law</b> <br><br>  These Terms and Conditions shall be governed by and
          construed in accordance with the laws of Kerala, India. Any disputes
          arising out of or related to these terms will be resolved in the
          courts of [insert jurisdiction].
        </span>
      </v-flex>
    </v-layout>
  </div>
</template>
    <script>
import axios from "axios";
export default {
  data() {
    return {
      pageData: {},
    };
  },
  beforeMount() {
    // this.getData();
  },
  methods: {
    getData() {
      axios({
        method: "GET",
        url: "/termsAndCondetions",
        // params: {
        //   Name: "Terms and Conditions",
        // },
      })
        .then((response) => {
          this.pageData = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>